import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Accordion, Button, Tab, Tabs } from 'react-bootstrap';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import TopNav from '../../TopNav/TopNav';
import JobNav from '../JobNav';
import JobOverviewBar from '../JobOverviewBar';
import ULForms from '../Additional/ULForms';
import PanelShopForms from './PanelShopForms';
import CSOFeedback from './CSOFeedback';
import JobReleaseForm from '../../JobReleaseForm';
import ShipEarlyForm from '../../ShipEarlyForm';
import InfoBubbleModal from '../../common/InfoBubbleModal';
import { getShipEarlyItemCount } from '../../../utils/itemCountUtils';
import { usePermissions } from '../../../hooks/usePermissions';
import useJobHandler, { useJobSync } from '../../../functions/JobHandler';
import './Forms.css';

export default function Forms() {
  const { id, formTab } = useParams();
  const navigate = useNavigate();
  const jobId = useSelector((state) => state.jobId.jobId);
  const shipEarlyParentDetails = useSelector((state) => state.jobDetails.jobDetails.shipEarlyParent || []);
  const { canView, canEdit } = usePermissions();
  const appsVisible = ['portal.additional-items.release-form', 'portal.ship-early.manage', 'portal.forms.cso-feedback'].some(key => canView(key));
  const visibleTabs = [appsVisible && 'apps', canView('portal.forms.panel-shop') && 'panel-shop', canView('portal.forms.ul') && 'ul'].filter(Boolean);
  const [showInfo, setShowInfo] = useState(false);
  const [csoOpened, setCsoOpened] = useState(false);
  useJobHandler();
  const { syncJob } = useJobSync();
  useEffect(() => {
    if (jobId) syncJob({ reuseRecent: true }).catch((error) => console.error('Forms: Failed to sync job data:', error));
  }, [jobId, syncJob]);

  if (visibleTabs.length && !visibleTabs.includes(formTab)) {
    return <Navigate to={`/${id}/forms/${visibleTabs[0]}`} replace />;
  }

  return <div>
    <TopNav />
    <JobOverviewBar />
    <JobNav keyValue="forms" />
    <Tabs
      id="job-forms-tabs"
      activeKey={formTab}
      onSelect={tab => { if (tab && tab !== formTab) navigate(`/${id}/forms/${tab}`); }}
      className="job-forms-tabs"
      aria-label="Form categories"
      mountOnEnter
    >
      {appsVisible && <Tab eventKey="apps" title="Apps">
        <Accordion alwaysOpen onSelect={keys => { if (keys?.includes('cso-feedback')) setCsoOpened(true); }}>

          {canView('portal.additional-items.release-form') && <Accordion.Item eventKey="release-form">
            <Accordion.Header><h3>Release for Scheduling Form</h3></Accordion.Header>
            <Accordion.Body><fieldset disabled={!canEdit('portal.additional-items.release-form')}><JobReleaseForm /></fieldset></Accordion.Body>
          </Accordion.Item>}
          {canView('portal.ship-early.manage') && <Accordion.Item eventKey="ship-early">
            <Accordion.Header><h3>Ship Early/ Direct Form{getShipEarlyItemCount(shipEarlyParentDetails, jobId)}</h3></Accordion.Header>
            <Accordion.Body>
              <div className="d-flex justify-content-start mb-3"><Button variant="link" className="p-0" onClick={() => setShowInfo(true)} aria-label="View Ship Early/ Direct Form information"><i className="bi bi-info-circle" aria-hidden="true" /></Button></div>
              <ShipEarlyForm />
            </Accordion.Body>
          </Accordion.Item>}
          {canView('portal.forms.cso-feedback') && <Accordion.Item eventKey="cso-feedback">
            <Accordion.Header><h3>CSO Feedback</h3></Accordion.Header>
            <Accordion.Body>{csoOpened && <CSOFeedback key={jobId} projectId={jobId} />}</Accordion.Body>
          </Accordion.Item>}
        </Accordion>
      </Tab>}
      {canView('portal.forms.panel-shop') && <Tab eventKey="panel-shop" title="Panel Shop">
        <div className="p-3">
          <PanelShopForms key={jobId} projectId={jobId} />
        </div>
      </Tab>}
      {canView('portal.forms.ul') && <Tab eventKey="ul" title="UL">
        <div className="p-3">
          <ULForms key={jobId} projectId={jobId} />
        </div>
      </Tab>}
    </Tabs>
    {!visibleTabs.length && <p className="p-3">You do not have access to job forms.</p>}
    <InfoBubbleModal show={showInfo} onHide={() => setShowInfo(false)} sectionName="ShipEarlyForm" value="Page" title="Ship Early/ Direct Form Information" displayAsOrderedList={false} />
  </div>;
}
